<template>
  <oxd-form-row v-for="(file, index) in modelValue" :key="index">
    <oxd-input-field
      :model-value="file"
      type="file"
      label="Justificatif (facultatif)"
      button-label="Parcourir"
      placeholder="Aucun fichier sélectionné"
      :rules="fileRules"
      @update:model-value="updateFile(index, $event)"
    />
    <oxd-button
      v-if="file || modelValue.length > 1"
      type="button"
      display-type="ghost"
      label="Retirer ce fichier"
      @click="removeFile(index)"
    />
  </oxd-form-row>
  <oxd-text tag="p" class="orangehrm-input-hint">
    PDF, PNG ou JPEG. 5 fichiers et 5 Mo au total par envoi. Vous pouvez aussi
    déposer les justificatifs plus tard depuis « Mes absences ».
  </oxd-text>
  <oxd-button
    v-if="modelValue.length < 5"
    type="button"
    display-type="ghost"
    label="Ajouter un autre fichier"
    @click="$emit('update:modelValue', [...modelValue, null])"
  />
</template>

<script>
export default {
  props: {
    modelValue: {type: Array, default: () => [null]},
  },
  emits: ['update:modelValue'],
  data() {
    return {
      fileRules: [
        (file) => {
          if (!file) return true;
          const extensions = /\.(pdf|png|jpe?g)$/i;
          // Browsers report aliases such as image/jpg for JPEG files; the
          // server validates the real content.
          const mimeTypes = [
            'application/pdf',
            'image/png',
            'image/x-png',
            'image/jpeg',
            'image/jpg',
            'image/pjpeg',
          ];
          return (
            (extensions.test(file.name) && mimeTypes.includes(file.type)) ||
            'Sélectionnez un fichier PDF, PNG ou JPEG.'
          );
        },
        (file) =>
          !file ||
          (Number(file.size) > 0 && Number(file.size) <= 5242880) ||
          'Le fichier doit être non vide et ne pas dépasser 5 Mo.',
        () =>
          this.modelValue.reduce(
            (total, file) => total + Number(file?.size || 0),
            0,
          ) <= 5242880 || 'Les fichiers ne doivent pas dépasser 5 Mo au total.',
      ],
    };
  },
  methods: {
    updateFile(index, file) {
      const files = [...this.modelValue];
      files[index] = file;
      this.$emit('update:modelValue', files);
    },
    removeFile(index) {
      const files = this.modelValue.filter((_, i) => i !== index);
      this.$emit('update:modelValue', files.length ? files : [null]);
    },
  },
};
</script>
